import { render, staticRenderFns } from "./VerDetalleRutaModal.vue?vue&type=template&id=46f34c27&"
import script from "./VerDetalleRutaModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleRutaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports